<template>
  <div class="magazines u-containar">
    <!-- <p>{{ page[0]}}</p> -->
    <h1>{{ page.title.rendered }}</h1>
    <div class="head">
      <ul v-if="page.acf.recommend_flags.length">
        <li v-for="flag in page.acf.recommend_flags" :key="flag">
          {{ flag }}
        </li>
      </ul>
      <time :datetime="page.date">{{ formatDate(page.date) }}</time>
      <SocialButtons class="social" />
    </div>
    <!-- <MagazinesMatchingContent
      :content="page.content.rendered"
      class="wp-content"
    /> -->
    <div
      v-html="page.content.rendered"
      class="wp-content matching-content"
    ></div>
    <SocialButtons class="social" />
  </div>
</template>

<script lang="ts">
// import { ref, watch } from 'vue'
import { ref, defineComponent } from 'vue'
import { useRoute } from 'vue-router'

import SocialButtons from '@/components/block/SocialButtons.vue'
// import MagazinesMatchingContent from '@/components/block/MagazinesMatchingContent.vue'

import { axiosSetting } from '@/utils/axiosSetting'

import '@/styles/wp-content.scss'
import '@/styles/matching-content.scss'

export default defineComponent({
  name: 'MagazinesMatchingDetail',
  components: {
    SocialButtons
    // MagazinesMatchingContent
  },
  beforeRouteEnter: async (to: any) => {
    const ajax = axiosSetting('cms', 'block')

    const data = await ajax
      .get(
        `${process.env.VUE_APP_WPAPI_URL}wp-json/wp/v2/pages?slug=${to.params.slug}`
      )
      .then((res) => {
        // return res.data
        return res.data[0]
      })

    // to.meta.breadCrumb.splice(1)

    to.meta.breadCrumb.push({ label: data.title.rendered })
    document.title = `${data.title.rendered} | ${document.title}`
  },
  setup() {
    const page = ref([])
    const route = useRoute()
    const ajax = axiosSetting('cms', 'block')

    const getPage = () => {
      ajax
        .get(
          `${process.env.VUE_APP_WPAPI_URL}wp-json/wp/v2/pages?slug=${route.params.slug}`
        )
        .then((res) => {
          // page.value = res.data
          page.value = res.data[0]
        })
    }

    const formatDate = (date: string) => {
      const dt = new Date(date)
      const year = dt.getFullYear()
      const month = dt.getMonth() + 1
      const day = dt.getDate()

      return `${year}年${month}月${day}日`
    }

    getPage()

    // watch(
    //   () => route.params.slug,
    //   () => {
    //     getPage()
    //   }
    // )

    return {
      page,
      formatDate
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.magazines {
  padding-top: 27px;
  max-width: 752px;
  @include mixins.media() {
    padding-top: 35px;
  }
}

h1 {
  font-size: 2.2rem;
  font-weight: normal;
  line-height: 1.5;
  margin-bottom: 20px;
  @include mixins.media() {
    margin-bottom: 28px;
  }
}

.head {
  margin-bottom: 19px;
  @include mixins.media() {
    display: flex;
    margin-bottom: 23px;
  }
}
ul {
  display: flex;
  flex-wrap: wrap;
  line-height: 1.8;
  font-size: 1rem;
  margin-bottom: 6px;
  @include mixins.media() {
    max-width: 175px;
    margin-right: 11px;
  }
}
li {
  background-color: var.$color-sub-bg-g;
  // padding: 4px 5px;
  padding: 0 5px;
  margin: 0 5px 5px 0;
  @include mixins.media() {
    max-height: 18px;
  }
}
time {
  display: block;
  margin-bottom: 25px;
  @include mixins.media() {
    line-height: 1.8rem;
  }
}
.social {
  align-items: start;
  @include mixins.media() {
    margin-left: auto;
  }
}
</style>
